module.exports = __webpack_public_path__ + "static/media/phone-blue.ac8cc3c4.png";